import { Form, Formik, FormikProps } from 'formik';
import * as React from 'react';
import { connect } from 'react-redux';

import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

import { AUTHENTICATION_STATE } from '../types/authentication';
import { withDefaultStyles } from '../utils/material-ui/hoc';

class Login extends React.Component<any, any> {
    public render() {
        return (
            <div style={this.props.style}>
                <Formik
                            initialValues={{
                                email: '@flybits.com',
                                password: ''
                            }}
                            onSubmit={this.props.onLogin}
                            render={this.form}
                        />
            </div>
        );
    }
    private form = (p: FormikProps<any>) => <Form>
        <DialogTitle id="alert-dialog-title">
            <Typography variant='inherit'>Authenticate with Flybits</Typography>
        </DialogTitle>
        <DialogContent id="alert-dialog-description">
            <TextField
                required={true}
                label="Email"
                type="email"
                name="email"
                InputLabelProps={{
                    shrink: true,
                }}
                margin="normal"
                variant="outlined"
                placeholder="@flybits.com"
                fullWidth={true}
                onChange={p.handleChange}
                onBlur={p.handleBlur}
                value={p.values.email || ''}
            />
            <TextField
                required={true}
                label="Password"
                type="password"
                name="password"
                InputLabelProps={{
                    shrink: true,
                }}
                margin="normal"
                variant="outlined"
                placeholder="password"
                fullWidth={true}
                onChange={p.handleChange}
                onBlur={p.handleBlur}
                value={p.values.password || ''}
            />
            { AUTHENTICATION_STATE.LOGIN_FAILED === this.props.authentication.state ? <Typography variant='inherit'>Login Failed</Typography> : null }
        </DialogContent>

        <DialogActions>
            <Button type="submit" color="primary" disabled={p.isSubmitting}>Login</Button>
        </DialogActions>
    </Form>
}


const mapStateToProps = (state, ownProps) => {
    return { ...state };
}

export default withDefaultStyles(connect(
    mapStateToProps,
)(Login));



// WEBPACK FOOTER //
// ./src/components/login-form.tsx